<template>
  <b-modal
    v-model="visivel"
    :title="modoEdicao ? 'Editar Budget do Líder' : 'Novo Budget do Líder'"
    size="lg"
    no-close-on-backdrop
    hide-footer
    @hidden="resetar"
  >
    <div v-if="carregando" class="text-center py-4"><b-spinner /></div>
    <b-form v-else @submit.prevent="salvar">
      <b-row>
        <b-col md="6">
          <b-form-group label="Supervisor *">
            <v-select
              v-model="form.supervisorid"
              :options="supervisores"
              :reduce="s => s.supervisorid"
              label="supervisornome"
              :disabled="modoEdicao"
              placeholder="Pesquisar supervisor..."
              @input="onSupervisorChange"
            >
              <template #no-options>Nenhum supervisor encontrado</template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Valor Total *">
            <b-form-input v-model.number="form.valor" type="number" step="0.01" min="0" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Data Início *">
            <b-form-input v-model="form.datainicio" type="date" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Data Término *">
            <b-form-input v-model="form.datatermino" type="date" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Descrição">
            <b-form-input v-model="form.descricao" maxlength="255" />
          </b-form-group>
        </b-col>
        <b-col v-if="modoEdicao" md="12">
          <b-form-checkbox v-model="form.ativo" switch class="mb-1">
            Budget ativo
          </b-form-checkbox>
        </b-col>
      </b-row>

      <hr />
      <div class="d-flex align-items-center mb-1 flex-wrap">
        <h6 class="mb-0">Earmarcação da verba (opcional)</h6>
        <b-badge variant="light-primary" class="ml-1">
          Alocado: {{ formatarMoeda(somaAlocacoes) }}
        </b-badge>
        <b-badge :variant="restante < 0 ? 'light-danger' : 'light-secondary'" class="ml-1">
          Restante: {{ formatarMoeda(restante) }}
        </b-badge>
      </div>
      <p class="text-muted small mb-1">
        Earmarque a verba por <strong>cliente</strong> (consumida por doações àquele
        cliente, independente do representante) e/ou por <strong>representante</strong>.
        A soma não pode ultrapassar o valor total.
      </p>

      <!-- Earmarcação por CLIENTE -->
      <h6 class="mt-1 mb-50">Por cliente</h6>
      <b-form-group>
        <v-select
          v-model="clienteSelecionado"
          :options="clientes"
          :reduce="c => c"
          :get-option-label="labelCliente"
          :filterable="false"
          placeholder="Pesquisar cliente por nome ou código..."
          @search="onBuscarCliente"
          @input="adicionarCliente"
        >
          <template #no-options>Digite ao menos 2 caracteres para pesquisar</template>
        </v-select>
      </b-form-group>
      <b-table
        v-if="clienteRows.length"
        :items="clienteRows"
        :fields="clienteFields"
        small
        responsive
        class="mb-1"
      >
        <template #cell(nome)="data">{{ data.item.nome }}</template>
        <template #cell(valor)="data">
          <b-form-input
            v-model.number="data.item.valor"
            type="number"
            step="0.01"
            min="0"
            size="sm"
            style="max-width:160px"
          />
        </template>
        <template #cell(acoes)="data">
          <b-button size="sm" variant="flat-danger" class="btn-icon" @click="removerCliente(data.index)">
            <feather-icon icon="Trash2Icon" size="14" />
          </b-button>
        </template>
      </b-table>
      <div v-else class="text-muted small mb-1">Nenhum cliente earmarcado.</div>

      <!-- Earmarcação por REPRESENTANTE -->
      <h6 class="mt-1 mb-50">Por representante</h6>
      <div v-if="!form.supervisorid" class="text-muted small mb-1">
        Selecione um supervisor para distribuir a verba entre seus representantes.
      </div>
      <div v-else-if="!representantes.length" class="text-muted small mb-1">
        Este supervisor não possui representantes vinculados.
      </div>
      <b-table
        v-else
        :items="alocacaoRows"
        :fields="repFields"
        small
        responsive
        class="mb-1"
      >
        <template #cell(representantenome)="data">
          {{ data.item.representantenome }}
          <b-badge v-if="!data.item.representanteativo" variant="light-secondary" class="ml-25">inativo</b-badge>
        </template>
        <template #cell(valor)="data">
          <b-form-input
            v-model.number="alocacaoMapRep[data.item.representanteid]"
            type="number"
            step="0.01"
            min="0"
            size="sm"
            style="max-width:160px"
          />
        </template>
      </b-table>

      <div class="text-right mt-2">
        <b-button variant="outline-secondary" class="mr-1" @click="visivel = false">Cancelar</b-button>
        <b-button variant="relief-success" :disabled="isSaving" type="submit">
          <b-spinner v-if="isSaving" small class="mr-25" />
          Salvar
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BRow, BCol, BFormGroup,
  BFormInput, BFormCheckbox, BButton, BSpinner, BTable, BBadge,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { mapActions, mapState } from 'vuex';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  name: 'BudgetLiderModal',
  components: {
    BModal, BForm, BRow, BCol, BFormGroup,
    BFormInput, BFormCheckbox, BButton, BSpinner, BTable, BBadge,
    vSelect,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      visivel: false,
      carregando: false,
      modoEdicao: false,
      budgetId: null,
      form: this.formVazio(),
      alocacaoMapRep: {},
      clienteRows: [],
      clienteSelecionado: null,
      repFields: [
        { key: 'representantenome', label: 'Representante' },
        { key: 'valor', label: 'Valor alocado', class: 'text-right' },
      ],
      clienteFields: [
        { key: 'nome', label: 'Cliente' },
        { key: 'valor', label: 'Valor alocado', class: 'text-right' },
        { key: 'acoes', label: '', class: 'text-center' },
      ],
    };
  },
  computed: {
    ...mapState('BudgetLider', ['supervisores', 'representantes', 'clientes', 'isSaving']),
    alocacaoRows() {
      return this.representantes.map(r => ({
        representanteid: r.representanteid,
        representantenome: r.representantenome,
        representanteativo: r.representanteativo,
      }));
    },
    somaAlocacoes() {
      const somaRep = Object.values(this.alocacaoMapRep).reduce((s, v) => s + (Number(v) || 0), 0);
      const somaCli = this.clienteRows.reduce((s, r) => s + (Number(r.valor) || 0), 0);
      return somaRep + somaCli;
    },
    restante() {
      return (Number(this.form.valor) || 0) - this.somaAlocacoes;
    },
  },
  methods: {
    ...mapActions('BudgetLider', ['carregarSupervisores', 'carregarRepresentantes', 'buscarPorId', 'criar', 'atualizar', 'buscarClientes']),
    formVazio() {
      return {
        supervisorid: null,
        valor: 0,
        datainicio: '',
        datatermino: '',
        descricao: '',
        ativo: true,
      };
    },
    async abrir(id = null) {
      this.resetar();
      this.visivel = true;
      this.carregando = true;
      try {
        if (!this.supervisores.length) await this.carregarSupervisores();
        if (id) {
          this.modoEdicao = true;
          this.budgetId = id;
          const b = await this.buscarPorId(id);
          this.form = {
            supervisorid: b.supervisorid,
            valor: Number(b.valor),
            datainicio: this.isoDate(b.datainicio),
            datatermino: this.isoDate(b.datatermino),
            descricao: b.descricao || '',
            ativo: !!b.ativo,
          };
          await this.carregarRepresentantes(b.supervisorid);
          const mapRep = {};
          const cliRows = [];
          (b.alocacoes || []).forEach((a) => {
            if (a.tipo_alvo === 'representante') {
              mapRep[a.alvo_id] = Number(a.valor);
            } else if (a.tipo_alvo === 'cliente') {
              cliRows.push({ clienteid: String(a.alvo_id), nome: a.alvo_nome || a.alvo_id, valor: Number(a.valor) });
            }
          });
          this.alocacaoMapRep = this.montarMapRep(mapRep);
          this.clienteRows = cliRows;
        }
      } finally {
        this.carregando = false;
      }
    },
    async onSupervisorChange() {
      await this.carregarRepresentantes(this.form.supervisorid);
      this.alocacaoMapRep = this.montarMapRep();
    },
    // Vue2: v-model com chaves dinâmicas em objeto observado só é reativo se a
    // chave já existir. Reconstrói o mapa com TODAS as chaves de representante
    // (preservando valores existentes) e reatribui o objeto inteiro.
    montarMapRep(existente = {}) {
      const out = { ...existente };
      this.representantes.forEach((r) => {
        if (out[r.representanteid] === undefined) out[r.representanteid] = 0;
      });
      return out;
    },
    // Debounce simples da busca de clientes no autocomplete.
    onBuscarCliente(termo, loading) {
      if (!termo || termo.length < 2) return;
      loading(true);
      clearTimeout(this._buscaTimer);
      this._buscaTimer = setTimeout(async () => {
        await this.buscarClientes(termo);
        loading(false);
      }, 350);
    },
    labelCliente(c) {
      if (!c) return '';
      const cod = c.clienteiderp ? ` (${c.clienteiderp})` : '';
      return `${c.clientenome || c.clienteid}${cod}`;
    },
    adicionarCliente(c) {
      if (!c) return;
      const id = String(c.clienteid);
      if (this.clienteRows.some(r => r.clienteid === id)) {
        this.clienteSelecionado = null;
        return;
      }
      this.clienteRows.push({ clienteid: id, nome: this.labelCliente(c), valor: 0 });
      this.clienteSelecionado = null;
    },
    removerCliente(index) {
      this.clienteRows.splice(index, 1);
    },
    montarAlocacoes() {
      const out = [];
      Object.entries(this.alocacaoMapRep).forEach(([alvoId, valor]) => {
        const v = Number(valor) || 0;
        if (v > 0) out.push({ tipo_alvo: 'representante', alvo_id: alvoId, valor: v });
      });
      this.clienteRows.forEach((r) => {
        const v = Number(r.valor) || 0;
        if (v > 0) out.push({ tipo_alvo: 'cliente', alvo_id: r.clienteid, valor: v });
      });
      return out;
    },
    async salvar() {
      if (!this.form.supervisorid) {
        return this.aviso('Selecione um supervisor');
      }
      if (!this.form.datainicio || !this.form.datatermino) {
        return this.aviso('Informe o período (início e término)');
      }
      if (!(Number(this.form.valor) > 0)) {
        return this.aviso('Informe um valor maior que zero');
      }
      if (this.restante < -0.00001) {
        return this.aviso('A soma das earmarcações excede o valor total');
      }
      const payload = {
        supervisorid: this.form.supervisorid,
        valor: Number(this.form.valor),
        datainicio: this.form.datainicio,
        datatermino: this.form.datatermino,
        descricao: this.form.descricao || null,
        ativo: this.form.ativo,
        alocacoes: this.montarAlocacoes(),
      };
      try {
        if (this.modoEdicao) {
          await this.atualizar({ id: this.budgetId, payload });
        } else {
          await this.criar(payload);
        }
        this.sucesso(this.modoEdicao ? 'Budget do líder atualizado' : 'Budget do líder criado');
        this.visivel = false;
        this.$emit('salvo');
      } catch (e) {
        // erro já exibido pelo client
      }
      return null;
    },
    resetar() {
      this.modoEdicao = false;
      this.budgetId = null;
      this.form = this.formVazio();
      this.alocacaoMapRep = {};
      this.clienteRows = [];
      this.clienteSelecionado = null;
    },
    isoDate(d) {
      if (!d) return '';
      return String(d).substring(0, 10);
    },
    formatarMoeda(v) {
      return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    aviso(title) {
      this.toast({ component: ToastificationContent, props: { title, icon: 'AlertTriangleIcon', variant: 'warning' } });
    },
    sucesso(title) {
      this.toast({ component: ToastificationContent, props: { title, icon: 'CheckCircleIcon', variant: 'success' } });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
